import Swiper from 'swiper';
import {Navigation, EffectFade, Autoplay, Pagination} from 'swiper/modules';
import 'swiper/css';
const homeMap = window.document.getElementById('homeMapPlaceholder');
const removePlaceholderMap  = window.document.getElementById('hideHomeMapPlaceholder');

new Swiper('.swiper-home', {
    modules: [Navigation, EffectFade, Autoplay],
    slidesPerView: 1,
    speed: 2000,
    spaceBetween: 0,
    effect: "fade",
    fadeEffect: {
        crossFade: true
    },
    loop: true,
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: '.slider-button-next',
        prevEl: '.slider-button-prev',
    },
});

new Swiper('.slider-news', {
    modules: [Navigation],
    slidesPerView: "auto",
    spaceBetween: 20,
    grabCursor: true,
    freeMode: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

if (homeMap) {
    document.addEventListener('click', (removePlaceholderMap) => {
        homeMap.style.display = 'none';
    });
}